import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { catchError, tap } from 'rxjs/operators';
import { LoginRequest } from '../models/login-request.model';
import { TokenStorageService } from '../services/token-storage.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  // private readonly API_URL = 'https://sprinkled-severity-upon.ngrok-free.dev';
  // private readonly API_URL = 'https://candle-posting-yin.ngrok-free.dev'
  private readonly API_URL =  'http://13.140.183.81:8080'

  private currentUserSubject: BehaviorSubject<any>;
  currentUser$;

  constructor(
    private http: HttpClient,
    private router: Router,
    private tokenStorage: TokenStorageService
  ) {
    const savedUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
    this.currentUserSubject = new BehaviorSubject<any>(savedUser);
    this.currentUser$ = this.currentUserSubject.asObservable();
  }

  get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  // 🔥 NEW LOGIC: Ab yeh backend se Role aur Privileges catch karega!
  login(credentials: LoginRequest): Observable<any> {
    return this.http.post<any>(`${this.API_URL}/login`, credentials).pipe(
      tap(response => {
        if (response.success && response.token) {
          
          this.tokenStorage.saveToken(response.token);

          // Backend se aane wale data ko direct Angular mein store kar rahe hain
          const user = {
            username: response.username || (credentials as any).email || 'User',
            role: response.role, // Yahan 'SUPER_ADMIN' aayega!
            privileges: response.privileges || [], // User permissions
            token: response.token
          };

          localStorage.setItem('currentUser', JSON.stringify(user));
          this.currentUserSubject.next(user);
        }
      })
    );
  }

  logout(): Observable<void> {
    const token = this.tokenStorage.getToken();

    if (!token) {
      this.clearSession();
      return of(undefined);
    }

    const headers = { Authorization: `Bearer ${token}` };

    return this.http.post<void>(`${this.API_URL}/logout`, null, { headers }).pipe(
      tap(() => this.clearSession()),
      catchError(error => {
        this.clearSession();
        return throwError(() => error);
      })
    );
  }

  isAuthenticated(): boolean {
    return this.tokenStorage.hasToken();
  }

  getToken(): string | null {
    return this.tokenStorage.getToken();
  }

  getCurrentUsername(): string {
    const user = this.currentUserSubject.value;
    return user?.username || user?.email || 'Unknown User';
  }

  private clearSession(): void {
    this.tokenStorage.clear();
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
    this.router.navigate(['/auth/login']);
  }
}